export default __webpack_public_path__ + "static/media/010_home.6480f522.mp4";